import { BusinessLogicError } from "~/lib/errors/businessLogicError";
import { type CompensationReviewData } from "~/services/compensation-review/compensationReviewContext";

export const getCompensationReviewBudget = (ctx: CompensationReviewData, budgetId: number) => {
  const budget = ctx.parameters.budgets.find((budget) => budget.id === budgetId);
  if (!budget) throw new BusinessLogicError("Budget not found");

  return budget;
};
